document.addEventListener("alpine:init", () => {
  Alpine.data("subNavigation", () => ({
    activeSection: null,

    init() {
      const sections = document.querySelectorAll('[data-anchor-id]');
      if (!sections.length) return;

      const filteredSections = [...sections].filter(section => 
        !section.closest('.Scroll__Switcher__Results__Wrapper')
      );

      if (!filteredSections.length) return;

      const observerOptions = {
        root: null,
        rootMargin: '-25% 0px -75% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        let mostVisibleSection = null;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            mostVisibleSection = entry.target.getAttribute('data-anchor-id');
          }
        });

        if (mostVisibleSection && this.activeSection !== mostVisibleSection) {
          this.$nextTick(() => {
            this.activeSection = mostVisibleSection;
          });
        }
      }, observerOptions);

      filteredSections.forEach((section) => {
        observer.observe(section);
      });
    },

    smoothScroll(anchorID) {
      if (!anchorID) return;

      const targetEl = document.getElementById(anchorID);
      if (!targetEl) return;

      const offset = 70;
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // Manually update activeSection after scrolling
      this.$nextTick(() => {
        this.activeSection = anchorID;
      });
    }
  }));
});
